import { render, staticRenderFns } from "./BillsMessenger.vue?vue&type=template&id=6f35824a&scoped=true&"
import script from "./BillsMessenger.vue?vue&type=script&lang=js&"
export * from "./BillsMessenger.vue?vue&type=script&lang=js&"
import style0 from "./BillsMessenger.vue?vue&type=style&index=0&id=6f35824a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35824a",
  null
  
)

export default component.exports